export default __webpack_public_path__ + "static/media/call.fac71e1a.svg";